import { Injectable } from '@angular/core';
import { ValidatorFn } from '@angular/forms';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { ParametersService } from '../services/parameters/parameters.service';
interface IFormatNumber {
  clearValue: string;
  format: string;
}

@Injectable({
  providedIn: 'root',
})
export class FormatNumberService {

  constructor(
    private parametersService: ParametersService,
  ) { }

  formatNumberPhone(phone: string): IFormatNumber {
    const cleaned = phone.replace(/\D/g, '').substring(0, 10);
    const regex = /^(\d{0,3})(\d{0,3})(\d{0,4})$/;
    const index1 = '$1';
    const parents = cleaned.length > 3 ? `(${index1})` : index1;
    const value = cleaned.replace(new RegExp(regex, 'g'), `${parents} $2 $3`);
    return { format: value.trim(), clearValue: cleaned };
  }

  currency(value: number, chunkLength: number = 3, chunkDelimiter: string = '.'): IFormatNumber {
    const newValue = value.toString().replace(/\D/g, '').replace(/^0+/, '').substring(0, 11);
    const regex = `\\d(?=(\\d{${chunkLength}})+$)`;
    const result = newValue.replace(new RegExp(regex, 'g'), `$&${chunkDelimiter}`);
    return { format: `$${result.trim()}`, clearValue: newValue };
  }

  numberPhoneValidator() {
    const prefijos = this.parametersService.getSetting(OpEnum.MOBILE_PHONE_PREFIXES);
    return (control): { [key: string]: boolean } | null => {
      const value: string = control.value;

      if (value !== undefined && value.length >= 3) {
        const prefix = value.substring(0, 3);
        const result = prefijos.includes(prefix);
        return !result ? { notPrefix: true } : null;
      }
      return null;
    };
  }

  amountFormat(value: any) {
    return value.replace('$', '').split(/\./).join('').trim();
  }

  pcoFormat(value: any) {
    return value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  }

  /**
   * Función que permite contar cantidad de decimales de un número
   * @param {number} val - Número con decimales
   * @returns - Cantidad de decimales
   */
  countDecimalDigits(val: number) {
    const char_array = val.toString().split(''); // split every single char
    const not_decimal = char_array.lastIndexOf('.');
    return (not_decimal < 0) ? 0 : char_array.length - (not_decimal !== 0 ? not_decimal + 1 : not_decimal);
  }

}
